// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vkSWn","right":"styles_right__3IIiC"};